import {
  fetchStudentGroupsShared,
  fetchWorksheetAssigneesShared,
  fetchWorksheetDetailShared,
} from '@/page/etc/MobileStudentSelect/mobileStudentSelect.query'

import {
  getQrRejectFromErrorCode,
  type QrScoringTarget,
  resolveQrScoringTarget,
} from './qrScoringTarget'
import type { WorksheetQrQuery } from './worksheetQr'

export type QrScoringEntry = QrScoringTarget | { type: 'error' }

/** 찍은 학습지 QR 로 열 채점 대상을 서버에 묻는다. 실패는 거절 사유로 바꾸고, 사유를 모르면 error 다 */
export const fetchQrScoringTarget = async (query: WorksheetQrQuery): Promise<QrScoringEntry> => {
  try {
    // 상세 조회는 다른 학원·삭제된 학습지를 거르는 용도다. 배정 목록은 둘 다 빈 목록으로 돌려준다
    const [, assignees, studentGroups] = await Promise.all([
      fetchWorksheetDetailShared(query.worksheetId),
      fetchWorksheetAssigneesShared(query.worksheetId),
      fetchStudentGroupsShared(),
    ])
    return resolveQrScoringTarget({
      query,
      assignees,
      isVisibleStudent: (studentId) => !!studentGroups.studentColl?.get(studentId),
    })
  } catch (error) {
    const reason = getQrRejectFromErrorCode((error as { code?: string } | undefined)?.code)
    return reason ? { type: 'reject', reason } : { type: 'error' }
  }
}
